import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faExclamationTriangle,
    faWrench,
    faSpinner,
    faCheck,
    faCheckSquare,
    faCheckCircle,
    faCopy,
    faExternalLinkAlt,
    faTimes,
    faArrowLeft,
    faInfoCircle,
    faArrowUp,
    faFileUpload,
    faStar,
    faEllipsisV,
    faBars,
    faPlusCircle,
} from '@fortawesome/free-solid-svg-icons'
import {
    faSquare,
    faStar as farStar,
    faCopy as farCopy,
} from '@fortawesome/free-regular-svg-icons'
import {
    faApple,
    faAndroid,
} from '@fortawesome/free-brands-svg-icons'

library.add(
    faFileUpload,
    faTimes,
    faArrowLeft,
    faCopy,
    farCopy,
    faExternalLinkAlt,
    faCheck,
    faCheckSquare,
    faCheckCircle,
    faExclamationTriangle,
    faWrench,
    faSpinner,
    faApple,
    faAndroid,
    faSquare,
    faInfoCircle,
    faArrowUp,
    faStar,
    farStar,
    faEllipsisV,
    faBars,
    faPlusCircle,
)
